import React from 'react';
import { View, TouchableOpacity } from 'react-native';

import PropTypes from 'prop-types';

import { Icon, VFText } from '@vfgroup-oneplatform/foundation/Components';
import { useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';

import FrameworkTestKeys from '../../../FrameworkTestKeys';
import { getThemeImages } from '../../../Themes';

import styles from './OptionItem.Styles';

function OptionItem({
  icon,
  title,
  description,
  onPress,
  images,
  descriptionAccessibilityLabel,
  iconAccessibilityLabel,
  rightIconAccessibilityLabel,
  titleAccessibilityLabel,
}) {
  const theme = useTheme();
  const Images = images || getThemeImages(theme.name);
  return (
    <TouchableOpacity
      onPress={onPress}
      accessible={false}
      testID={FrameworkTestKeys.settingsOptionItemTO}
    >
      <View style={styles.titleContainer} testID={FrameworkTestKeys.settingsOptionItemTitleView}>
        <View
          style={styles.iconTextContainer}
          testID={FrameworkTestKeys.settingsOptionItemTitleTextView}
        >
          <Icon
            type="image"
            source={Images[icon]}
            size={34}
            style={styles.icon(theme)}
            accessibilityLabel={iconAccessibilityLabel}
            testID={iconAccessibilityLabel}
          />
          <VFText
            type="primary"
            i18nKey={title}
            style={styles.title}
            testKey={titleAccessibilityLabel}
          />
        </View>

        <Icon
          type="image"
          size={32}
          source={Images.ic_chevron_right}
          accessibilityLabel={rightIconAccessibilityLabel}
          testID={rightIconAccessibilityLabel}
        />
      </View>

      {description ? (
        <View
          style={styles.subTitleContainer}
          testID={FrameworkTestKeys.settingsOptionItemDescriptionView}
        >
          <VFText
            type="primary"
            i18nKey={description}
            style={styles.subTitle}
            testKey={descriptionAccessibilityLabel}
          />
        </View>
      ) : null}
    </TouchableOpacity>
  );
}

OptionItem.propTypes = {
  icon: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  onPress: PropTypes.func.isRequired,
  images: PropTypes.object,
  titleAccessibilityLabel: PropTypes.string,
  descriptionAccessibilityLabel: PropTypes.string,
  iconAccessibilityLabel: PropTypes.string,
  rightIconAccessibilityLabel: PropTypes.string,
};

export default OptionItem;
